// NGRX
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { RoleTemplateActions, RoleTemplateActionTypes } from '../_actions/role-template.actions';
// Models
import { RoleTemplate } from '../_models/role-template.model';
import { QueryParamsModel } from '../../_base/crud/models/query-models/query-params.model';

export interface RoleTemplateState extends EntityState<RoleTemplate> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: any;
  lastCreatedRoleTemplateId: number;
  lastQuery: QueryParamsModel;
  error: any | null;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;

  isAllRoleTemplatesLoaded: boolean;
  queryRowsCount: number;
  queryResult: RoleTemplate[];
  allRoleTemplates: RoleTemplate[];
}

export const adapter: EntityAdapter<RoleTemplate> = createEntityAdapter<RoleTemplate>();

export const initialRoleTemplateState: RoleTemplateState = adapter.getInitialState({
  isAllRoleTemplatesLoaded: false,
  queryRowsCount: 0,
  queryResult: [],
  lastCreatedRoleTemplateId: undefined,
  totalCount: 0,
  listLoading: false,
  actionsloading: false,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  allRoleTemplates: [],
  error: null,
  latestSuccessfullAction: null,
});

export function roleTemplatesReducer(
  state = initialRoleTemplateState,
  action: RoleTemplateActions,
): RoleTemplateState {
  switch (action.type) {
    case RoleTemplateActionTypes.RoleTemplatesPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedRoleTemplateId: undefined,
      };
    case RoleTemplateActionTypes.RoleTemplatesActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case RoleTemplateActionTypes.RoleTemplateOnServerCreated:
      return {
        ...state,
      };
    case RoleTemplateActionTypes.RoleTemplateOnServerUpdated:
      return {
        ...state,
      };
    case RoleTemplateActionTypes.RoleTemplateOnServerDeleted:
      return {
        ...state,
      };
    case RoleTemplateActionTypes.RoleTemplatesOnServerDeleted:
      return {
        ...state,
      };
    case RoleTemplateActionTypes.RoleTemplateCreated:
      return adapter.addOne(action.payload.roleTemplate, {
        ...state,
        lastCreatedRoleTemplateId: action.payload.roleTemplate.id,
      });
    case RoleTemplateActionTypes.RoleTemplateUpdated:
      return adapter.updateOne(action.payload.partialRoleTemplate, state);
    case RoleTemplateActionTypes.RoleTemplateDeleted:
      return adapter.removeOne(action.payload.id, state);
    case RoleTemplateActionTypes.RoleTemplatesDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case RoleTemplateActionTypes.AllRoleTemplatesLoaded:
      return {
        ...state,
        allRoleTemplates: action.payload.roles,
      };
    case RoleTemplateActionTypes.RoleTemplatesPageCancelled:
      return {
        ...state,
        listLoading: false,
        showInitWaitingMessage: false,
        queryRowsCount: 0,
        queryResult: [],
        lastQuery: new QueryParamsModel({}),
      };
    case RoleTemplateActionTypes.RoleTemplatesPageLoaded:
      return adapter.addMany(action.payload.roleTemplates, {
        ...initialRoleTemplateState,
        listLoading: false,
        queryRowsCount: action.payload.totalCount,
        totalCount: action.payload.totalCount,
        allRoleTemplates: state.allRoleTemplates,
        queryResult: action.payload.roleTemplates,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    case RoleTemplateActionTypes.ThrowRoleTemplateError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case RoleTemplateActionTypes.FireRoleTemplateSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
